import { useMemo } from 'react';
import { createTableColumn, useTableFeatures } from '@fluentui/react-components';
import { usePersistedColumnSizing } from '@shared/hooks';

export default function useDetectionsColumns<Row extends { id: string }>(
  tableId: string,
  columnIds: readonly string[],
  sizingParams: {
    autoFitColumns?: boolean;
    columnSizingOptions: Record<string, { defaultWidth?: number; minWidth?: number; idealWidth?: number }>;
  }
) {
  const columns = useMemo(() => columnIds.map((columnId) => createTableColumn<Row>({ columnId })), [columnIds]);

  const { columnSizing_unstable } = useTableFeatures({ columns, items: [] }, [
    usePersistedColumnSizing(tableId, sizingParams),
  ]);

  return columnSizing_unstable;
}
